import Text from 'components/common/Text';
import ConfirmDialog from 'components/Modal/ConfirmDialog';
import React, { FC } from 'react';
import { DeliveryState } from 'types/api';
import { useMutationDeliveries } from '../graphQL/hooks/useMutationDeliveries';

const CONFIRM_DIALOG_TEXT = {
  [DeliveryState.PAID]: (
    <Text
      color="#1b1c1e"
      size="20px"
      weight={600}
      style={{ lineHeight: '28px' }}
    >
      '결제 완료 {`->`} 배송 준비'
      <br />
      상태로 변경할까요?
    </Text>
  ),
  [DeliveryState.PACKING]: (
    <Text
      color="#1b1c1e"
      size="20px"
      weight={600}
      style={{ lineHeight: '28px' }}
    >
      '배송 준비 {`->`} 배송 시작' <br />
      상태로 변경할까요?
    </Text>
  ),
  [DeliveryState.ISSUED]: (
    <Text
      color="#1b1c1e"
      size="20px"
      weight={600}
      style={{ lineHeight: '28px' }}
    >
      '배송 시작 {`->`} 배송 완료' <br />
      상태로 변경할까요?
    </Text>
  ),
  [DeliveryState.COMPLETED]: (
    <Text
      color="#1b1c1e"
      size="20px"
      weight={600}
      style={{ lineHeight: '28px' }}
    >
      '배송 완료 {`->`} 구매확정' <br />
      상태로 변경할까요?
    </Text>
  ),
};

interface Props {
  deliveryId: string;
  deliveryStatus: DeliveryState;
  onClose: () => void;
  onAccept: () => void;
}

const DeliveryConfirmDialog: FC<Props> = props => {
  const { deliveryId, deliveryStatus, onClose, onAccept } = props;

  const {
    handlePackDeliveries,
    handleIssueDeliveries,
    handleCompleteDeliveries,
    handleConfirmDeliveries,
  } = useMutationDeliveries();

  const handleAccept = () => {
    switch (deliveryStatus) {
      case DeliveryState.PAID: {
        handlePackDeliveries([deliveryId], onAccept);
        break;
      }
      case DeliveryState.PACKING: {
        handleIssueDeliveries(
          [
            {
              deliveryId,
            },
          ],
          onAccept,
        );
        break;
      }
      case DeliveryState.ISSUED: {
        handleCompleteDeliveries([deliveryId], onAccept);
        break;
      }
      case DeliveryState.COMPLETED: {
        handleConfirmDeliveries([deliveryId], onAccept);
        break;
      }
    }
  };

  return (
    <ConfirmDialog
      title={CONFIRM_DIALOG_TEXT[deliveryStatus]}
      onAcceptText="네, 변경할게요"
      onCloseText="아니요"
      onClose={onClose}
      onAccept={handleAccept}
      buttonStyle={{ padding: '12px 24px', background: '#0071e9' }}
    />
  );
};

export default DeliveryConfirmDialog;
